import { WebsiteEnv } from './website-env';

// us
let ga4Id = 'G-84XJ7MW63B';
let gtmId = 'GTM-P565JQB';
let facebookId = '1368027759939536';
let heroDashToken = 'cb139f09a51db027bc91ec404a405799';

if (WebsiteEnv.isUnitedKingdom) {
  ga4Id = 'G-302ZHYJ0BJ';
  gtmId = 'GTM-N2SZWG9';
  facebookId = '707382621645900';
} else if (WebsiteEnv.isCanada) {
  ga4Id = 'G-EN92R4P8BL';
  gtmId = 'GTM-MT8DSFNJ';
  facebookId = '1186506776025744';
  heroDashToken = '9cbc7dd9025f1a62524276cee45ce430';
}

export const trackingIds = {
  ga4Id,
  gtmId,
  facebookId,
  heroDashToken,
};
